var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1747 0H2.32531C1.7086 0 1.11715 0.244988 0.681069 0.681069C0.244988 1.11715 0 1.7086 0 2.32531V29.1747C0 29.7914 0.244988 30.3829 0.681069 30.8189C1.11715 31.255 1.7086 31.5 2.32531 31.5H29.1747C29.7914 31.5 30.3829 31.255 30.8189 30.8189C31.255 30.3829 31.5 29.7914 31.5 29.1747V2.32531C31.5 1.7086 31.255 1.11715 30.8189 0.681069C30.3829 0.244988 29.7914 0 29.1747 0ZM9.38875 26.8341H4.65281V11.7906H9.38875V26.8341ZM7.0175 9.70594C6.48029 9.70291 5.95601 9.54082 5.51084 9.24012C5.06566 8.93941 4.71954 8.51357 4.51615 8.01634C4.31276 7.51911 4.26122 6.97278 4.36804 6.44628C4.47486 5.91979 4.73524 5.43674 5.11633 5.05809C5.49742 4.67944 5.98213 4.42216 6.5093 4.31873C7.03647 4.2153 7.58246 4.27034 8.07837 4.47692C8.57429 4.6835 8.9979 5.03234 9.29574 5.47944C9.59358 5.92654 9.7523 6.45184 9.75188 6.98906C9.75694 7.34873 9.68955 7.70574 9.5537 8.03881C9.41786 8.37187 9.21635 8.67418 8.96119 8.92771C8.70602 9.18124 8.40243 9.38081 8.06849 9.51451C7.73456 9.64821 7.37713 9.71331 7.0175 9.70594ZM26.845 26.8472H22.1113V18.6288C22.1113 16.205 21.0809 15.4569 19.7509 15.4569C18.3466 15.4569 16.9684 16.5156 16.9684 18.69V26.8472H12.2325V11.8016H16.7869V13.8863H16.8481C17.3053 12.9609 18.9066 11.3794 21.35 11.3794C23.9925 11.3794 26.8472 12.9478 26.8472 17.5416L26.845 26.8472Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5,
    height: 31.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cbe09f6c40cc0273f791361617a6e4f3.svg";
export { ForwardRef as ReactComponent };